export default function NotificationBadge({ count }) {
  if (!count || count === 0) return null;

  return (
    <span className="absolute -top-1 -right-1 flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-bold text-white bg-action-primary rounded-full border-2 border-white shadow-md">
      {count > 99 ? '99+' : count}
    </span>
  );
}
